<template>
  <div class="aj-tree-tab" :style="{'--bgColor': color,}">
    <van-tabs v-model="activeTab" :color="color" swipeable>
      <van-tab :title="item[tabLabel]" :name="item[tabValue]" v-for="item in getOptionList"></van-tab>
    </van-tabs>
    <infineTab v-model="childValue" v-if="nextList.length > 0" :optionList="nextList" :tabIndex="tabIndex + 1" :hasAll="hasAll" :tabLabel="tabLabel" :tabValue="tabValue" :tabChild="tabChild" :color="color"></infineTab>
  </div>
</template>

<script>
// import infineTab from './infineTab.vue';
export default {
  name: 'infineTab',
  props: {
    tabLabel: {
      type: String,
      default: 'label'
    },
    tabValue: {
      type: String,
      default: 'value'
    },
    tabChild: {
      type: String,
      default: 'children'
    },
    color:{
      type: String,
      default: '#3775ff'
    },
    optionList: {
      type: Array,
      default: () => []
    },
    tabIndex: {
      type: Number,
      default: 0
    },
    hasAll: {
      type: String,
      default: null
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  computed: {
    activeTab: {
      get() {
        return this.value[this.tabIndex] ? this.value[this.tabIndex] : '';
      },
      set(value) {
        const newList = JSON.parse(JSON.stringify(this.value));
        newList[this.tabIndex] = value;
        let valueList = [];
        for (let i = 0; i <= this.tabIndex; i++) {
          valueList.push(newList[i]);
        }
        this.$emit('input', valueList);
      }
    },
    childValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    nextList: {
      get() {
        const selItem = this.findItem(this.optionList, this.tabValue, this.activeTab);
        if (selItem && selItem[this.tabChild] && selItem[this.tabChild].length > 0) {
          return selItem[this.tabChild];
        } else {
          return [];
        }
      }
    },
    getOptionList: {
      get() {
        if (this.hasAll) {
          let list = JSON.parse(JSON.stringify(this.optionList));
          let obj = {};
          obj[this.tabLabel] = '全部';
          obj[this.tabValue] = this.hasAll ? this.hasAll : 'all';
          list.unshift(obj);
          return list;
        } else {
          return this.optionList;
        }
      }
    }
  },
  methods: {
    findItem(list, key, value) {
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        if (item[key] === value) {
          return item;
        }
        if (item[this.tabChild] && item[this.tabChild].length > 0) {
          if (this.findItem(item[this.tabChild], key, value)) {
            return this.findItem(item[this.tabChild], key, value);
          }
        }
      }
      return null;
    }
  }
};
</script>

<style lang="scss" scoped>
.aj-tree-tab {
  width: 100%;
  ::v-deep.van-tabs--line {
    .van-tabs__wrap{
      height: auto;
      .van-tabs__nav--line{
        padding-bottom: 0;
        .van-tabs__line{
          bottom: 0.1rem;
          display: none;
        }
      }
      .van-tab{
        flex: unset;
        flex-shrink: 0;
        padding: 0.3rem 1rem;
        background-color: rgb(224,232,246);
        color: #333;
        border-radius: 0.9rem;
        font-size: 0.8rem;
        line-height: unset;
        margin-right: 0.5rem;
        margin-bottom: 0.5rem
      }
      .van-tab--active{
        background-color: var(--bgColor);
        color: #fff;
      }
      .van-tabs__nav--line.van-tabs__nav--complete{
        padding: 0;
      }
    }
  }
}
</style>
